module.exports = __webpack_public_path__ + "static/media/nationbuilder-mark-solid.8a03bf1c.svg";